'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'fish-bones';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e304';
var svgPathData = 'M76.2 240l-38-101.5L96 177.1l0-38.5L32 96 0 128 48 256 0 384l32 32 64-42.7 0-38.5L38.1 373.5 76.2 272l67.8 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 48 0 0 96 0 32 32 0L576 256 448 112l-32 0 0 32 0 96-48 0 0-80 0-16-32 0 0 16 0 80-64 0 0-80 0-16-32 0 0 16 0 80-64 0 0-80 0-16-32 0 0 16 0 80-67.8 0zM448 351.8l0-79.8 0-32 0-79.8L533.2 256 448 351.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFishBones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;